import React from 'react'
import { Collapse, Badge, Button, Label, Media, CustomInput } from 'reactstrap'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import ReactHtmlParser from 'react-html-parser'
import IframeResizer from 'iframe-resizer-react'

import Slider from '@mui/material/Slider'
import toast from 'react-hot-toast'
import { SketchPicker } from 'react-color'
import { ColorPickerWrapper } from './ColorPicker'
import { UserContext } from '../contexts/UserContext'
import useTranslation from '../hooks/UseTranslation'
import PremiumModal from './PremiumModal'

const Integration = () => {
  const { t } = useTranslation()
  const { loggedUser } = React.useContext(UserContext)
  const [code, setCode] = React.useState()
  const [color, setColor] = React.useState('636aee')
  const [hideLogo, setHideLogo] = React.useState(false)
  const [isOpen, setIsOpen] = React.useState(false)
  const [pageSize, setPageSize] = React.useState(3)
  const [showPremium, setShowPremium] = React.useState(false)
  const [url, setUrl] = React.useState()

  React.useEffect(() => {
    if (loggedUser) {
      let newUrl = `${process.env.NEXT_PUBLIC_HOST}/embed/u/rows/${loggedUser.slug}?pageSize=${pageSize}&primaryColor=${color}`
      if (hideLogo) {
        newUrl += '&hl=1'
      }
      setUrl(newUrl)
    }
  }, [loggedUser, pageSize, color, hideLogo])

  React.useEffect(() => {
    if (url) {
      setCode(
        `<style>
        iframe {
            width: 1px;
            min-width: 100%;
        }
        </style>
        <script src="${process.env.NEXT_PUBLIC_HOST}/content/js/iframeResizer.min.js"></script>
        <iframe id="${loggedUser.slug}" src=${url} frameBorder="0" scrolling="no"></iframe>
        <script>
        iFrameResize({}, '#${loggedUser.slug.replace(/\./g, '\\\\.')}')
        </script>
        `
      )
    }
  }, [url])
  return (
    <div className='text-block'>
      <PremiumModal
        isOpen={!!showPremium}
        toggle={() => setShowPremium(false)}
      />
      <div className='d-flex justify-content-between'>
        <h5 className='text-first-letter mb-4'>
          {t('guru_integration_website')}
        </h5>
      </div>
      <Media className='text-muted mb-4'>
        <Media body className='mt-n1'>
          {ReactHtmlParser(t('guru_integration_website_content'))}
        </Media>
      </Media>
      <div className='text-muted'>
        <div className='text-right'>
          <Button
            color='link'
            onClick={() => setIsOpen((i) => !i)}
            className='mb-3 p-0'
          >
            {isOpen ? t('close') : t('guru_integration_cta')}
          </Button>
        </div>
        <Collapse isOpen={isOpen}>
          <div className='mb-2'>
            <Label className='form-label'>
              {t('guru_integration_page_size')}
            </Label>
            <Slider
              marks
              color='primary'
              valueLabelDisplay='auto'
              aria-label='slider'
              step={1}
              min={1}
              max={10}
              value={pageSize}
              onChange={(e, newVal) => setPageSize(newVal)}
            />
            <Label className='form-label'>
              {t('guru_integration_main_color')}{' '}
              <Badge className='ml-2' color='premium'>
                {t('premium')}
              </Badge>
            </Label>
            <ColorPickerWrapper
              onClick={
                !loggedUser?.active_premium && (() => setShowPremium((p) => !p))
              }
              color={color}
            >
              <SketchPicker
                disableAlpha
                presetColors={[]}
                color={color}
                onChangeComplete={({ hex }) => setColor(hex.substring(1))}
              />
            </ColorPickerWrapper>
            <Label className='form-label'>
              {t('guru_integration_hide_logo')}
              <Badge className='ml-2' color='premium'>
                {t('premium')}
              </Badge>
            </Label>
            <CustomInput
              type='switch'
              id='hideLogo'
              name='hideLogo'
              className='mb-2'
              onChange={(e) => {
                if (loggedUser?.active_premium) {
                  setHideLogo(e.target.checked)
                } else {
                  setShowPremium((p) => !p)
                }
              }}
              checked={hideLogo}
              label={
                <strong className='text-sm'>
                  {hideLogo ? t('yes') : t('no')}
                </strong>
              }
            />
            <p className='mt-4'>
              {ReactHtmlParser(t('guru_integration_explainations'))}
            </p>
            <p>{ReactHtmlParser(t('guru_integration_explainations2'))}</p>
            <ul>
              <li>
                <a
                  target='_blank'
                  rel='noreferrer'
                  href='https://support.wix.com/fr/article/%C3%A9diteur-wix-int%C3%A9grer-un-site-ou-un-widget'
                >
                  {t('guru_integration_guide', 'Wix')}
                </a>
              </li>
              <li>
                <a
                  target='_blank'
                  rel='noreferrer'
                  href='https://elementor.com/help/html-widget/'
                >
                  {t('guru_integration_guide', 'Elementor (lien en anglais)')}
                </a>
              </li>
            </ul>
            <div className='text-right'>
              <CopyToClipboard
                text={code}
                onCopy={() => {
                  toast.success(t('copied'))
                }}
              >
                <Button color='primary' className='mb-3'>
                  {t('copy')}
                </Button>
              </CopyToClipboard>
            </div>
            {loggedUser && (
              <IframeResizer
                scrolling='no'
                frameBorder={0}
                checkOrigin={false}
                // log
                src={url}
                style={{ width: '1px', minWidth: '100%' }}
              />
            )}
          </div>
        </Collapse>
      </div>
    </div>
  )
}

export default Integration
